/* src/app/user-authorizations/update-multiple-authorizations/update-multiple-authorizations.component.scss */
/*# sourceMappingURL=update-multiple-authorizations.component.css.map */
